import { AppBar, Toolbar } from '@mui/material'
import React, { useState } from 'react'
import { TopBarSectionVisibilityType } from '../types'
import { DesktopToolBar } from './desktop'
import { MobileMenu, MobileToolBar } from './mobile'

export interface TopBarProps extends Partial<TopBarSectionVisibilityType> {
  useAdminTool: boolean
}

/**
 * Render top bar
 */
export const TopBar = ({
  showLangAndUser = true,
  showNavigationLinks = true,
  showUserName = true,
  useAdminTool
}: TopBarProps) => {
  const [anchorElement, setAnchorElement] = useState<HTMLButtonElement | null>(
    null
  )
  const menuOpen = Boolean(anchorElement)

  const handleMobileMenuOpen = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setAnchorElement(e.currentTarget)
  }

  const handleMobileMenuClose = () => {
    setAnchorElement(null)
  }

  const topBarSectionVisibilityProps = {
    showLangAndUser,
    showNavigationLinks,
    showUserName
  }

  return (
    <>
      <AppBar className="topbar" elevation={0} position="fixed">
        <DesktopToolBar
          useAdminTool={useAdminTool}
          {...topBarSectionVisibilityProps}
        />
        <MobileToolBar
          handleMobileMenuOpen={handleMobileMenuOpen}
          menuOpen={menuOpen}
        />
      </AppBar>
      <Toolbar />
      <MobileMenu
        handleMobileMenuClose={handleMobileMenuClose}
        onClose={handleMobileMenuClose}
        open={menuOpen}
        useAdminTool={useAdminTool}
        {...topBarSectionVisibilityProps}
      />
    </>
  )
}
